









































import { snakeCase } from 'lodash'
import { Component, Prop, Ref, VModel, Watch } from 'vue-property-decorator'

import DrawerWidthMixin from '../../../../../../logic/helpers/DrawerWidthMixin'
import { CustomConnection } from '../../../logic/Connections/CustomConnection'
import CustomEditor from '../../../logic/Editor/CustomEditor'
import { BaseMenuItems, PasteMenuItem, CtxMenuItem } from '../logic/MenuItems'
import ContextMenuItem from './Menu/ContextMenuItem.vue'

@Component({
  components: {
    ContextMenuItem
  },
  data() {
    return {
      snakeCase,
    }
  }
})
export default class NonSelectedMenu extends DrawerWidthMixin {
  @VModel() isVisible!: boolean

  @Prop() editor!: CustomEditor

  @Prop() position!: { x: number, y: number }

  @Ref('submenu') submenuContainer!: HTMLDivElement

  activeKey: string | null = null

  @Watch('isVisible')
  onIsVisibleChange(state: boolean) {
    if (!state) {
      this.setActiveKey(null)
    }
  }

  selectMenuItem(item: CtxMenuItem) {
    if (item?.items?.length) {
      this.setActiveKey(item.key)
    } else {
      this.setActiveKey(null)
      this.createNode(item.value)
    }
  }

  handlePasteClick() {
    this.editor.pasteNodes()
    this.isVisible = false
  }

  setActiveKey(key: string | null): void {
    if (this.activeKey !== key) {
      this.activeKey = key
    } else {
      this.activeKey = null
    }
  }

  get subMenuStyle(): Record<string, string | number> {
    if (this.windowWidth > 576) {
      return {
        ...this.leftPosition ? { left: '100%' } : { right: '100%' },
        ...this.bottomPosition ? { bottom: 0 } : { top: 0 },
      }
    } else {
      return {
        left: '50%',
        transform: 'translateX(-50%)',
        top: '100%',
        borderTop: '1px solid rgba(0,0,0,0.3)'
      }
    }
  }

  get pasteMenuItem() {
    return PasteMenuItem
  }

  get leftPosition(): boolean {
    if (this.submenuContainer) {
      /** 224, потому что у первого меню класс w-56, который в свою очередь равен +-224px или 14rem */
      return window.innerWidth - (this.position.x + 224) > this.submenuContainer.clientWidth
    }

    return false
  }

  get bottomPosition(): boolean {
    if (this.submenuContainer) {
      return this.position.y > this.submenuContainer.clientHeight
    }
    return false
  }

  get menuItems() {
    if (this.editor) {
      return BaseMenuItems
    }

    return []
  }

  createNode(type: string): void {
    this.editor.createNewNode(type)
      .then((node) => {
        if (node && this.editor.pseudoOutput) {
          const mainInputKey = node.mainInput

          if(mainInputKey && node.inputs.get(mainInputKey)) {
            this.editor.connect(this.editor.pseudoOutput, node.inputs.get(mainInputKey)!,
              {
                visible: true,
                d: '',
                id: CustomConnection.LastConnectionId += 1,
                statistics: null
              })
          }
        }
    })
      .finally(() => {
        this.isVisible = false
      })
  }
}
